






















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class RkBtn extends Vue {
  @Prop({ default: '' }) private size!: string;
  @Prop({ default: false }) private ghost!: boolean;
}
